import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './GameDetailModal.module.css';

const InfoTip = ({ label, text }) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  return (
    <span className={styles.infoTipWrapper} ref={wrapperRef}>
      <button
        type="button"
        className={styles.infoTipButton}
        onClick={() => setOpen((prev) => !prev)}
        aria-label={label}
        aria-expanded={open}
      >
        !
      </button>
      {open && (
        <span className={styles.infoTipPopover} role="tooltip">
          {text}
        </span>
      )}
    </span>
  );
};

InfoTip.propTypes = {
  label: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default InfoTip;
